const calcFrameRate = (ActualFrameCount: number, ActualLength: number) => {
    return Math.trunc(ActualFrameCount / ActualLength);
};

export default calcFrameRate;